/* Actions */
export const GET_REQUEST = "GET_REQUEST";
export const POPULATE_LIST = "POPULATE_LIST";

/* Mutations */
export const POPULATE_LIST_SUCCESS = "POPULATE_LIST_SUCCESS";
